<script>
    import FormRow from "../../../components/FormRow.svelte";
    import FormColumn from "../../../components/FormColumn.svelte";
    import TextInput from "../../../components/TextInput.svelte";
    import TextDisplay from "../../../components/TextDisplay.svelte";
    import CheckboxButton from "../../../components/CheckboxButton.svelte";
    import YesNoGroup from "../../../components/YesNoGroup.svelte";

    export let treatments = [];
    export let disabled = null;

    const initialise = () => {};

    initialise();

    const otherDetailsTreatmentTypeIds = [4, 9];
</script>

<div>
    <h2>List of Treatments</h2>

    <div class="desktop">
        <FormRow>
            <FormColumn cols="4">
                <p class="label">Treatment Required</p>
            </FormColumn>
            <FormColumn cols="4"></FormColumn>
            <FormColumn cols="4">
                <p class="label">Still require this treatment</p>
            </FormColumn>
        </FormRow>
    </div>

    <FormRow class="listEntry mt-2">
        {#each treatments as treatment, i (treatment)}
            {#if otherDetailsTreatmentTypeIds.includes(treatment.treatmentTypeId)}
                <FormColumn cols="4" class="mb-2">
                    <p class="label mobile">Treatment Required</p>
                    <CheckboxButton
                        {disabled}
                        name="treatmentName{i}"
                        bind:checked={treatment.checked}
                        label={treatment.treatmentName}
                    ></CheckboxButton>
                </FormColumn>
                <FormColumn cols="4" class="mb-2">
                    {#if treatment.checked}
                        {#if !disabled}
                            <TextInput
                                bind:value={treatment.otherDetails}
                                id="OtherDetails{i}"
                            />
                        {:else}
                            <TextDisplay
                                value={treatment.otherDetails}
                                id="OtherDetails{i}"
                            />
                        {/if}
                    {/if}
                </FormColumn>
                <FormColumn cols="4" class="mb-2">
                    <p class="label mobile">Still require this treatment</p>

                    {#if treatment.checked}
                        <YesNoGroup
                            {disabled}
                            name="stillRequired{i}"
                            bind:value={treatment.stillRequired}
                        />
                    {/if}
                </FormColumn>
            {:else}
                <FormColumn cols="4" class="mb-2">
                    <p class="label mobile">Treatment Required</p>
                    <CheckboxButton
                        {disabled}
                        name="treatmentName{i}"
                        bind:checked={treatment.checked}
                        label={treatment.treatmentName}
                    ></CheckboxButton>
                </FormColumn>
                <FormColumn cols="4" class="mb-2 d-md-block d-none"></FormColumn>
                <FormColumn cols="4" class="mb-2">
                    {#if treatment.checked}
                        <p class="label mobile">Still require this treatment</p>

                        <YesNoGroup
                            {disabled}
                            name="stillRequired{i}"
                            bind:value={treatment.stillRequired}
                        />
                    {/if}
                </FormColumn>
            {/if}
        {/each}
    </FormRow>
</div>

<style>

    @media (min-width:768px) {
        .mobile {
            display: none;
        }
    }

    @media (max-width:768px) {
        .desktop {
            display: none;
        }
    }

</style>
